import _createClass from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */

/** @type {SchemaType} */
export var Schema = /*#__PURE__*/_createClass(
/**
 * @param {SchemaType['property']} property
 *   Property.
 * @param {SchemaType['normal']} normal
 *   Normal.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns
 *   Schema.
 */
function Schema(property, normal, space) {
  _classCallCheck(this, Schema);
  this.normal = normal;
  this.property = property;
  if (space) {
    this.space = space;
  }
});
Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = undefined;